import { render, staticRenderFns } from "./closeDialog.vue?vue&type=template&id=b27dbfc4&scoped=true"
import script from "./closeDialog.vue?vue&type=script&lang=js"
export * from "./closeDialog.vue?vue&type=script&lang=js"
import style0 from "./closeDialog.vue?vue&type=style&index=0&id=b27dbfc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27dbfc4",
  null
  
)

export default component.exports